module.exports = __webpack_public_path__ + "img/airtel.0e02083f.png";